import { computed } from 'vue';
import { useStoreGetters } from 'dashboard/composables/store';

/**
 * "Super Admin" no Chatwoot não é um papel (role) de conta como
 * `administrator`/`agent` — é um TIPO de usuário separado, via Single
 * Table Inheritance (`SuperAdmin < User`, coluna `type` na tabela
 * `users`). É a mesma lógica usada para mostrar o link "Super Admin
 * Console" no menu de perfil, em SidebarProfileMenu.vue.
 * @returns {Boolean} - True se o usuário logado for um SuperAdmin.
 */
export function useSuperAdmin() {
  const getters = useStoreGetters();

  const currentUser = computed(() => getters.getCurrentUser.value);
  const isSuperAdmin = computed(() => currentUser.value?.type === 'SuperAdmin');

  return {
    isSuperAdmin,
  };
}
